module.exports = __webpack_public_path__ + "static/media/1_2.45c5c314.png";